import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/course/course-cover.png';
var _hoisted_1 = {
  class: "course-design"
};
var _hoisted_2 = {
  class: "filter-bar"
};
var _hoisted_3 = {
  class: "filter-bar-left"
};
var _hoisted_4 = {
  class: "filter-bar-right"
};
var _hoisted_5 = {
  key: 0,
  class: "loading-box"
};
var _hoisted_6 = {
  key: 0,
  class: "course-list"
};
var _hoisted_7 = {
  class: "list-scroll"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "course-content"
};
var _hoisted_10 = ["onClick"];
var _hoisted_11 = {
  class: "course-content-tags"
};
var _hoisted_12 = {
  key: 1,
  class: "tag"
};
var _hoisted_13 = {
  class: "course-content-info"
};
var _hoisted_14 = {
  class: "course-btns"
};
var _hoisted_15 = ["onClick"];
var _hoisted_16 = ["onClick"];
var _hoisted_17 = {
  class: "course-list-page"
};
var _hoisted_18 = {
  key: 1,
  class: "empty-box"
};
import { MessagePlugin, DialogPlugin } from 'tdesign-vue-next';
import { computed, onMounted, ref, toRaw } from 'vue';
import { SearchIcon } from 'tdesign-icons-vue-next';
import { getCourseList, curriculumCiteFun, courseIsCatelogFully } from '@/api/index-bei';
import { getAppUrl, createCourse, goEdit, previewCourse } from '@/util/inspirationCentre';
import { skipUrl as skipUrlOpen } from '@/util/util';
import PublishStep from './components/PublishStep.vue';
import { getStore } from '@/util/store.js';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var accessToken = getStore({
      name: 'access_token'
    });
    var inspirationCentre = ref('');
    var prepareLesson = ref('');
    var loading = ref(true);
    var getTopLinks = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getAppUrl('inspirationCentre');
            case 1:
              _t = _context.v;
              if (_t) {
                _context.n = 2;
                break;
              }
              _t = '';
            case 2:
              inspirationCentre.value = _t;
              _context.n = 3;
              return getAppUrl('prepareLesson');
            case 3:
              _t2 = _context.v;
              if (_t2) {
                _context.n = 4;
                break;
              }
              _t2 = '';
            case 4:
              prepareLesson.value = _t2;
            case 5:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function getTopLinks() {
        return _ref.apply(this, arguments);
      };
    }();
    var timeSort = ref('desc');
    var toggleTimeSort = function toggleTimeSort() {
      timeSort.value = timeSort.value === 'desc' ? 'asc' : 'desc';
      getList();
    };
    var searchKey = ref('');
    var currentPage = ref(1);
    var pageSize = ref(20);
    var total = ref(0);
    var onPageSizeChange = function onPageSizeChange(size) {
      pageSize.value = size;
      getList();
    };
    var onChange = function onChange(pageInfo) {
      currentPage.value = pageInfo.current;
      getList();
    };
    var courseList = ref([]);
    var getList = function getList() {
      loading.value = true;
      console.log('get list', timeSort.value, searchKey.value);
      var params = {
        resourceTypeDictItemCode: 'nation',
        sortBy: timeSort.value,
        current: currentPage.value,
        size: pageSize.value,
        searchContent: searchKey.value,
        periodDictItemCode: '',
        subjectDictItemCode: '',
        tutorialVersionDictItemCode: '',
        tutorialId: null,
        firstTutorialDirId: '',
        secondTutorialDirId: '',
        threeTutorialDirId: '',
        fourTutorialDirId: ''
      };
      getCourseList(params).then(function (res) {
        console.log('getCourseList', res);
        if (res.data.code === 0) {
          courseList.value = res.data.data.records;
          total.value = res.data.data.total;
        }
      }).finally(function () {
        loading.value = false;
      });
    };
    var handleSearch = function handleSearch() {
      currentPage.value = 1;
      getList();
    };
    var refreshList = function refreshList() {
      getList();
    };
    var handleCreateCourse = function handleCreateCourse() {
      if (inspirationCentre.value) {
        createCourse();
      } else {
        MessagePlugin.warning('暂无备课应用权限，无法创建学程！');
      }
    };
    var handleInspiration = function handleInspiration() {
      if (inspirationCentre.value) {
        var url = "".concat(inspirationCentre.value, "?inspirationCentre=%2Fsub-inspiration-centre-svc%2Fcourse&token=").concat(accessToken);
        skipUrlOpen(url);
      } else {
        MessagePlugin.warning('暂无备课应用权限！');
      }
    };
    var publishVisible = ref(false);
    var currentPublishCourse = ref(null);
    var getPublishPermission = function getPublishPermission(course) {
      return inspirationCentre.value;
    };
    var handlePublish = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(course) {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (inspirationCentre.value) {
                _context2.n = 1;
                break;
              }
              MessagePlugin.warning('暂无应用权限，无法发布学程！');
              return _context2.a(2);
            case 1:
              if (!(!inspirationCentre.value && course.preStatus === 0)) {
                _context2.n = 2;
                break;
              }
              MessagePlugin.warning('暂无备课应用权限，无法发布学程！');
              return _context2.a(2);
            case 2:
              console.log('handlePublish', toRaw(course));
              if (!(course.preStatus === 0)) {
                _context2.n = 4;
                break;
              }
              _context2.n = 3;
              return curriculumCiteFun(course.id);
            case 3:
              res = _context2.v;
              if (res.data.code === 0) {
                course.preStatus = 1;
                console.log('已发送至备课');
                currentPublishCourse.value = course;
                publishVisible.value = true;
              }
              _context2.n = 5;
              break;
            case 4:
              console.log('已经在备课中，直接发布');
              courseIsCatelogFully(course.id).then(function (res) {
                if (res.data.code === 0) {
                  if (res.data.data) {
                    // 目录完整再校验校本库标引属性
                    if ((course === null || course === void 0 ? void 0 : course.resourceOwnership) === 'school_lib' && (course === null || course === void 0 ? void 0 : course.indexFlag) === 0) return MessagePlugin.warning('学程标引属性未设置，无法发布，请前往备课设置后再发布。');
                    currentPublishCourse.value = course;
                    publishVisible.value = true;
                  } else {
                    MessagePlugin.warning('学程目录不完整，无法发布，请前往备课完善后再发布。');
                    return;
                  }
                } else {
                  MessagePlugin.error('校验学程目录完整性失败');
                }
              }).catch(function (err) {
                MessagePlugin.error(err.massage || '校验学程目录完整性失败');
              });
            case 5:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function handlePublish(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var handlePublishClose = function handlePublishClose(data) {
      if (data === 'success') {
        refreshList();
      }
      currentPublishCourse.value = null;
      publishVisible.value = false;
    };
    var handlePreview = function handlePreview(course) {
      previewCourse(course);
    };
    var handleEdit = function handleEdit(course) {
      if (!inspirationCentre.value) {
        MessagePlugin.warning('暂无应用权限！');
        return;
      }
      console.log('handleEdit', toRaw(course));
      if (course.courseVersion === 1) {
        MessagePlugin.warning('旧版本学程无法编辑');
      } else {
        if (course.discuss) {
          var dialog = DialogPlugin({
            header: '提示',
            body: '该学程已用于教研活动，修改学程会影响教研活动的过程记录，可以通过复制学程进行编辑',
            confirmBtn: '取消',
            cancelBtn: '继续编辑',
            onConfirm: function onConfirm() {
              dialog.destroy();
            },
            onClose: function onClose(_ref3) {
              var e = _ref3.e,
                trigger = _ref3.trigger;
              if (trigger === 'cancel') {
                goEdit(course);
              } else {
                dialog.hide();
              }
            }
          });
        } else {
          goEdit(course);
        }
      }
    };
    onMounted(function () {
      getTopLinks();
      getList();
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_input = _resolveComponent("t-input");
      var _component_t_loading = _resolveComponent("t-loading");
      var _component_t_pagination = _resolveComponent("t-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: _normalizeClass(['btn-sort', timeSort.value]),
        onClick: toggleTimeSort
      }, [_cache[3] || (_cache[3] = _createTextVNode(" 编辑时间", -1)), _createVNode(_component_svg_icon, {
        class: "icon-order",
        name: "course-order",
        size: "16"
      })], 2), _createVNode(_component_t_input, {
        modelValue: searchKey.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return searchKey.value = $event;
        }),
        placeholder: "请输入内容"
      }, {
        suffixIcon: _withCtx(function () {
          return [_createVNode(_unref(SearchIcon), {
            style: {
              cursor: 'pointer'
            },
            onClick: handleSearch
          })];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "btn-refresh",
        onClick: refreshList
      }, [_cache[4] || (_cache[4] = _createTextVNode(" 刷新", -1)), _createVNode(_component_svg_icon, {
        class: "icon-refresh",
        name: "course-refresh",
        size: "16"
      })]), _createElementVNode("div", {
        class: _normalizeClass(['btn-create', {
          disabled: !inspirationCentre.value
        }]),
        onClick: handleInspiration
      }, [_createVNode(_component_svg_icon, {
        class: "icon-create",
        name: "prepare-icon",
        size: "16"
      }), _cache[5] || (_cache[5] = _createTextVNode("前往备课 ", -1))], 2), _createElementVNode("div", {
        class: _normalizeClass(['btn-create', {
          disabled: !inspirationCentre.value
        }]),
        onClick: handleCreateCourse
      }, [_createVNode(_component_svg_icon, {
        class: "icon-create",
        name: "course-create",
        size: "16"
      }), _cache[6] || (_cache[6] = _createTextVNode("新建学程 ", -1))], 2)])]), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_t_loading, {
        text: "数据加载中...",
        size: "small"
      })])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [courseList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList.value, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "course-list-item"
        }, [_createElementVNode("div", {
          class: "course-cover",
          onClick: function onClick($event) {
            return handlePreview(item);
          }
        }, _toConsumableArray(_cache[7] || (_cache[7] = [_createElementVNode("img", {
          src: _imports_0
        }, null, -1)])), 8, _hoisted_8), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
          class: "course-content-title",
          onClick: function onClick($event) {
            return handlePreview(item);
          }
        }, _toDisplayString(item.resourceName || '暂无标题'), 9, _hoisted_10), _createElementVNode("div", _hoisted_11, [item.courseVersion === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_cache[8] || (_cache[8] = _createElementVNode("span", {
          class: "tag"
        }, "旧版本", -1)), _cache[9] || (_cache[9] = _createElementVNode("span", {
          class: "tag"
        }, "仅查看", -1))], 64)) : _createCommentVNode("", true), item.pubStatus === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_12, "已发布")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("span", null, "编辑时间: " + _toDisplayString(item.updateTime), 1), _createElementVNode("span", null, "创编人: " + _toDisplayString(item.creatorName), 1), _createElementVNode("span", null, "原创人: " + _toDisplayString(item.originalUserName ? item.originalUserName : item.originalName), 1)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
          class: _normalizeClass(['course-btns-item', {
            disabled: !getPublishPermission(item)
          }]),
          onClick: function onClick($event) {
            return handlePublish(item);
          }
        }, " 发布 ", 10, _hoisted_15), _createElementVNode("div", {
          class: _normalizeClass(['course-btns-item', {
            disabled: !inspirationCentre.value
          }]),
          onClick: function onClick($event) {
            return handleEdit(item);
          }
        }, "编辑", 10, _hoisted_16)])]);
      }), 128))]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_t_pagination, {
        modelValue: currentPage.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return currentPage.value = $event;
        }),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = function ($event) {
          return pageSize.value = $event;
        }),
        total: total.value,
        "show-jumper": "",
        pageSizeOptions: [20, 50, 100, 200, 500],
        onChange: onChange,
        onPageSizeChange: onPageSizeChange
      }, null, 8, ["modelValue", "pageSize", "total"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_svg_icon, {
        name: "empty-content",
        size: "120",
        class: "icon"
      })]))], 64)), publishVisible.value ? (_openBlock(), _createBlock(PublishStep, {
        key: 2,
        "publish-visible": publishVisible.value,
        course: currentPublishCourse.value,
        onClose: handlePublishClose
      }, null, 8, ["publish-visible", "course"])) : _createCommentVNode("", true)]);
    };
  }
};